import auth from "../../middlewares/auth";

export const groupRoutes = [
    {
        path: '/groups',
        component: () => import(/* webpackChunkName: "groups" */ '../../views/groups/Group'),
        name: 'groups',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['group-manage']
        }
    },
    {
        path: '/group/:id',
        component: () => import(/* webpackChunkName: "groups" */ '../../views/groups/GroupForm'),
        name: 'update-group',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['group-manage']
        }
    },
    {
        path: '/create-group',
        component: () => import(/* webpackChunkName: "groups" */ '../../views/groups/GroupForm'),
        name: 'create-group',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['group-manage']
        }
    },
    {
        path: '/group/:id/show',
        component: () => import(/* webpackChunkName: "groups" */ '../../views/groups/ViewGroup'),
        name: 'view-group',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['group-manage']
        }
    },
]